<template>
    <el-dialog
            :title="titleName"
            :visible.sync="dialogFormVisible"
            width="45%"
            class="diccss"
    >
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>
            <el-form-item label="编码" :label-width="formLabelWidth" :required="true" prop="fco">
                <el-input v-model="form.fco" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="名称" :label-width="formLabelWidth" :required="true" prop="fna">
                <el-input v-model="form.fna" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth" :required="true" prop="sta">
                <el-form-item label="状态" :label-width="formLabelWidth" :required="true" prop="sta">
                    <el-radio-group v-model="form.sta">
                        <el-radio label="0">正常</el-radio>
                        <el-radio label="1">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth" prop="rem">
                <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.rem">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                form: {
                    id: '',
                    zhangTaoId: null,
                    fco: '',
                    fna: '',
                    fty: '',
                    fxh: null,
                    sta: '0',
                    rem: '',
                },
                rules: {
                    id: [{required: true, message: '请输入主键', trigger: 'blur'}],
                    zhangTaoId: [{required: true, message: '请输入账套ID', trigger: 'blur'}],
                    fco: [{required: true, message: '请输入编码', trigger: 'blur'}],
                    fna: [{required: true, message: '请输入名称', trigger: 'blur'}],
                    fty: [{required: true, message: '请输入辅助类型', trigger: 'blur'}],
                    sta: [{required: true, message: '请输入状态', trigger: 'blur'}]
                },
                formLabelWidth: '66px'
            };
        },
        methods: {
            int(id,fty) {

                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.zhangTaoId = null;
                this.form.fco = '';
                this.form.fna = '';
                this.form.fty = fty;
                this.form.fxh = null;
                this.form.sta = '0';
                this.form.rem = '';

                if (id == 'add') {
                    this.titleName = "辅助项目-新增";
                    this.url = "/business/fuZhuXm/save";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/fuZhuXm/getMax'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'fty': fty
                        })
                    }).then(r => {
                        this.form.fxh = r.data.data;
                        this.form.fco = this.form.fty + this.form.fxh;
                    })
                } else {
                    this.titleName = "辅助项目-修改";
                    this.url = "/business/fuZhuXm/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/fuZhuXm/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        if(!this.form.fty){
                            this.$message({
                                type: 'error',
                                message: '辅助类型不能为空'
                            })
                            return false;
                        }

                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .diccss >>> .el-dialog__body {
        padding: 25px 35px 5px 10px;
    }
</style>
